import React, { Component } from 'react';
import HeaderTools from '../../PageComponents/Header/HeaderTools';
import apiService from '../../Services/apiServices';
import { useToasts } from 'react-toast-notifications'
import { confirmAlert } from 'react-confirm-alert'; 
import Search from '../../PageComponents/Search/Search';
import DataTable from '../../PageComponents/UI/Tables/DataTable';
import ImportData from '../Tools/ImportData';
import Partner from '../../Models/Partner';
import ExcelExport from '../../PageComponents/Excel/ExcelExport';
import helper from '../../Services/helper';

function withToast(Component) {
  return function WrappedComponent(props) {
      const toastFuncs = useToasts() 
      return <Component {...props} {...toastFuncs} />;
  }
}

class Partners extends Component {
  constructor(props) {
    super(props);

    this.state = {
      partners: [],
      partnerTypes: [],
      search:'',
      showImportData: false 
    };

    //this.search = this.search.bind(this);
    this.excelExportRef = React.createRef();
  }
  handleChange(event) {
    // Get event value
    let searchValue = event.target.value;

    // Set the state to trigger a re-rendering
    this.setState({ search: searchValue });
  }
//componentDidMount onload render data
  componentDidMount() {
      this.getPartnerTypes()
      this.getPartners('#active');
      window.addEventListener("hashchange", e =>  this.getPartners(this.props.location.hash));
      
  }

  showImportData = () => {
    this.setState({
      showImportData: !this.state.showImportData
    })
  }

  getPartnerTypes = () => {
    apiService().get('partnerTypes')
      .then(response => {
        if(response.success) {
          this.setState({ partnerTypes: response.data });
        }
      })
  }

  getPartners = (filter) => {
      apiService()
        // .query('partners', `status=${filter === '#active' ? 1 : 0}`)
        .get('partners')
        .then((response) => {
          if (response.success) {
            let resData = response.data;
            resData.forEach(e => {
              if(e.supplier === true && e.customer === true){
                e.pType = helper().translate("SUPPLIER") + "/"+ helper().translate("BUYER");
                e.partnerType === 6 ?  e.pType +=  " - " +  helper().translate("UNITY") : ""
              }else if(e.supplier === true){
                e.pType = helper().translate("SUPPLIER")
                e.partnerType === 6 ?  e.pType +=  " - " +  helper().translate("UNITY") : ""
              }else if(e.customer === true){
                e.pType = helper().translate("BUYER")
                e.partnerType === 6 ?  e.pType +=  " - " + helper().translate("UNITY") : ""
              }
            });
          
            if(filter === '#active'){
              var data = resData.filter(items => items['status'] !== 0);
              this.setState({ partners: data });
              
            }
            else {
              var data = resData.filter(items => items['status'] === 0);
              this.setState({ partners: data });
              
            }
          } else {
            console.log('Error:' + response.errorMessage);
          }
      });
  }

  onFieldChange = (e) => {
    this.setState({
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  edit = (item) => {
    window.location.href = `#/partner/${item.id}`
  }


  exportToExcel = () => {
    // let table = document.getElementById('table-to-xls-1').innerHTML;
    let fileName = helper().translate("PARTNERS");
    // return helper().exportToExcel(table, fileName)
    this.excelExportRef.current.exportToExcel(fileName)
  }

  delete = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui" >
            <h1>A jeni te sigurt?</h1>
            <p>Dëshironi të fshini këtë artikull?</p>
            <button
              onClick={() => {
                  apiService().delete('partners', id)
                      .then((response)=>{this.responseMessage(response, 'Delete Successfully')});
                  onClose();
              }}
            >
              Po , Fshije!
            </button>
            <button onClick={onClose}>Jo</button>
          </div>
        );
      }
    }) 
  }

  responseMessage = (response, message) => {
    let that = this;
    if(response.success){
        that.getPartners('#active');
        that.props.addToast( message, { appearance: 'success', autoDismiss: true, });
    }
    else{
      that.props.addToast('Ka ndodhur nje gabim!', { appearance: 'error', autoDismiss: true, });
    }
  }

  headers = [
    { key: 'id', columnName: 'Id' },
    { key: 'companyName', columnName: 'Emri' },
    { key: 'type', columnName: 'Tipi'},
    { key: 'fiscalNo', columnName: 'NUI' },
    { key: 'customer', columnName: 'Blerës' },
    { key: 'supplier', columnName: 'Furnitor' },
    { key: 'mobilePhone', columnName: 'Kontakti' },
  ]

  exportCsv = (data) => {
     const newArr = data.map(({sid, name, surname, saveAs, phone, comment, businessNo, vatNo, address, city, partnerOrigin, createdAt, createdBy, changedAt, changedBy, status, discount, paymentTypeId, importOrLocal, branchNo, parentId, termsOfPaymentsId, cityName, country, ...rest}) => {
      return rest;
    });
    helper().exportCsv(newArr, true, 'Partners');
  }

  render() {
    let { partners } = this.state;
    let { partnerTypes } = this.state;
    let hash = this.props.location.hash
    
    const headers = [
      { key: 'companyName', columnName: 'Emri' },
      { key: 'pType', columnName: helper().translate("PARTNER_TYPE") },
      { key: 'fiscalNo', columnName: 'NUI' },
      { key: 'mobilePhone', columnName: 'Kontakti' }
    ]
    const headersExcel = [
      { key: 'id', columnName: 'Id' , dontShowMenu : true },
      { key: 'companyName', columnName: 'Emri' },
      { key: 'pType', columnName: helper().translate("PARTNER_TYPE") },
      { key: 'fiscalNo', columnName: 'NUI' },
      { key: 'mobilePhone', columnName: 'Kontakti' },
    ]
    let searchPartners = partners,
            searchString = this.state.search.trim().toLowerCase();

        if (searchString.length > 0) {
            // We are searching. Filter the results.
            //searchPartners = searchPartners.filter((e) => e.CompanyName.toLowerCase().match(searchString));

            searchPartners = searchPartners.filter(item => {
              return (
                item?.companyName?.toLowerCase().match(searchString) ||
                item?.pType?.toLowerCase().match(searchString) ||
                item?.fiscalNo?.toLowerCase().match(searchString) ||
                item?.mobilePhone?.toLowerCase().match(searchString)
              )
            });
        }
    return (
      <div>
      <div className="container-fluid px-2 mt-3">
        <Search new={hash ==='#active' ? "#/partner" : ''} change={(e) => this.handleChange(e)}  importData={this.showImportData} excel={() => this.exportToExcel()}/>
        <ExcelExport data={searchPartners} headers={headersExcel} type={'other'} ref={this.excelExportRef} hideContent={true} />
        <div className="card shadow mt-1">
          <div className="card-header py-2">
            <h6 className="m-0 font-weight-bold text-primary">Partneret</h6>
          </div>
          {this.state.showImportData && <ImportData queryName='partners' model={new Partner()} callBack={this.getPartners('#active')} />}
          <DataTable headers={headers} data={searchPartners} edit={ this.edit} delete={this.delete}  />
          
        </div>
      </div>
    </div>
    );
  }
}

export default withToast(Partners);



// WEBPACK FOOTER //
// ./src/PageComponents/Items/Items.js